module.exports = __webpack_public_path__ + "static/img/posz_2.61f04c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/3dapps/skybox/tidepool/posz_2.jpg
// module id = qt+t
// module chunks = 2